import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { Container, } from '@mui/material';

const MainLayout = () => (
  <>
    <Navbar />
    <Container
      maxWidth={false}
      disableGutters
      sx={{
        px: { xs: 2, sm: 4, md: 6 }, // padding laterale responsive
        pt: 2,
        pb: 1
      }}
    >
      <Outlet />
    </Container>
  </>
);

export default MainLayout;
